<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="主订单号">
                <el-input v-model="formInline.orderMainNo" placeholder="主订单号" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="退款明细号">
                <el-input v-model="formInline.refundPayId" placeholder="退款明细号" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="getOrderRefundFailRecordList">查询</el-button>
                <el-button type="success" @click="refundPay">手动退款</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="orderRefundFailRecordList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="orderMainNo" label="主订单号" width="120"></el-table-column>
            <el-table-column prop="refundPayId" label="退款明细号" width="110"></el-table-column>
            <el-table-column prop="reqParam" label="请求参数" width="330"></el-table-column>
            <el-table-column prop="resParam" label="响应参数" width="520"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="90"></el-table-column>
            <el-table-column prop="reqNum" label="请求次数" width="90">
            <template slot-scope="scope">
                <el-input v-model="scope.row.reqNum" >
                </el-input>
            </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注信息" width="160"></el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="warning " size="mini" @click="modifyRefundNum(scope.row)">修改</el-button>
                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getOrderRefundFailRecordList,refundPay,modifyRefundNum,deleteRefundInfo} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                loading: true,
                orderRefundFailRecordList: []// 订单退款失败列表
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getOrderRefundFailRecordList();
        },
        methods: {
            getOrderRefundFailRecordList(){
                this.loading = true;
                getOrderRefundFailRecordList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.orderRefundFailRecordList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            refundPay(){
             refundPay(this.formInline).then((res) => {
                 if(res.data.status==200){
                     this.$message({
                         showClose: true,
                         message: '成功',
                         type: 'success'
                     });
                 }else{
                     this.$message({
                         showClose: true,
                         message: res.data.message,
                         type: 'error'
                     });
                 }
             });
            },

            modifyRefundNum(row){
                console.log(row);
                const loading = this.$loading(this.GCONFIG.loadingParam);
                modifyRefundNum({refundPayId:row.refundPayId,reqNum:row.reqNum}).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getOrderRefundFailRecordList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            handleDel(row){
                this.$confirm('删除退款信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteRefundInfo({refundPayId:row.refundPayId}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getOrderRefundFailRecordList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getOrderRefundFailRecordList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getOrderRefundFailRecordList();
            }
        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/orderRefundFailRecord.vue